export const AssetsTranslateFileDir = './assets/i18n/';
export const CdnTranslateFileDir = '/lang/';